module.exports = __webpack_public_path__ + "static/img/3huifengCard.0a09e2b5.png";